import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';

const SimplePopup = ({ onClose, checkoutUrl }) => {

    const popupRef = useRef(null);
    const cart = useSelector((state) => state.cart);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="simple-popup">
            <div className="simple-popup__content" ref={popupRef}>
                <span className="simple-popup__close-icon" onClick={onClose}></span>
                <p className='simple-popup__title'>
                    {translate('coptikk.product.addedtocart')}
                </p>
                <a className='simple-popup__button'  href={checkoutUrl ? checkoutUrl : cart.checkoutUrl}>
                    {translate('coptikk.mypage.to.checkout')}
                </a>
            </div>
        </div>
    );
};

export default SimplePopup;